/* tslint:disable */
/* eslint-disable */
/**
 * DigitalOrderForm
 * DigitalOrderForm backend API
 *
 * Shared plumbing for the hand written clients.
 *
 * The generated api.ts builds its requests through generated helpers; the clients written by hand instead
 * share this one, so that adding an endpoint does not mean copying query handling, headers and the bearer
 * token set up by the api provider all over again.
 */

import { AxiosPromise } from 'axios';

import { BASE_PATH, BaseAPI } from './base';

export class TypedApi extends BaseAPI {
	protected request<TResponse>(
		method: string,
		path: string,
		options: any = {},
		extra: {
			query?: Record<string, unknown>;
			data?: unknown;
			contentType?: string;
		} = {},
	): AxiosPromise<TResponse> {
		const baseOptions = this.configuration?.baseOptions ?? {};

		// The base is a placeholder: only pathname and search are kept, the real one is prepended below.
		const url = new URL(path, 'https://example.com');
		const queryParameters = new URLSearchParams(url.search);

		for (const key in extra.query ?? {}) {
			const value = (extra.query as Record<string, unknown>)[key];
			if (value !== undefined && value !== null && value !== '') {
				queryParameters.set(key, String(value));
			}
		}
		for (const key in options?.query ?? {}) {
			queryParameters.set(key, options.query[key]);
		}
		url.search = queryParameters.toString();

		const requestOptions: any = {
			method,
			...baseOptions,
			...options,
			headers: {
				...(baseOptions.headers ?? {}),
				...(options?.headers ?? {}),
			},
			url:
				(this.configuration?.basePath || this.basePath || BASE_PATH) +
				url.pathname +
				url.search,
		};

		if (extra.data !== undefined) {
			requestOptions.data = extra.data;
			requestOptions.headers['Content-Type'] =
				extra.contentType ?? 'application/json';
		}

		return this.axios.request(requestOptions);
	}
}
